export default "__VITE_ASSET__1c5eded0__"